import React from "react";
import "./VimeoStyles.scss";

const Vimeo = ({ code }) => {
  return <iframe className='vimeo' src={`https://player.vimeo.com/video/${code}`} allowFullScreen />;
};

export default Vimeo;
